var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPt006ColorDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "front_color_diamond",
    transform: "translate(-500 -680)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_987",
    "data-name": "Rectangle 987",
    transform: "translate(500 728) rotate(-45)",
    fill: "#fff4e6",
    stroke: "#f28608",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.882,
    height: 67.882,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 59.882,
    height: 59.882,
    rx: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "front_end",
    transform: "translate(525 708)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_641",
    "data-name": "Group 641"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_439",
    "data-name": "Rectangle 439",
    width: 40,
    height: 40,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_643",
    "data-name": "Group 643",
    transform: "translate(1.667 1.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_642",
    "data-name": "Group 642"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M21.667,14.333,23.75,9.75l4.583-2.083L23.75,5.583,21.667,1,19.583,5.583,15,7.667,19.583,9.75Z",
    transform: "translate(8.333 -1)",
    fill: "#f28608"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M21.667,15l-2.083,4.583L15,21.667l4.583,2.083,2.083,4.583L23.75,23.75l4.583-2.083L23.75,19.583Z",
    transform: "translate(8.333 8.333)",
    fill: "#f28608"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M18.5,13.167,14.333,4l-4.167,9.167L1,17.333,10.167,21.5l4.167,9.167L18.5,21.5l9.167-4.167Zm-2.517,5.817-1.65,3.633-1.65-3.633L9.05,17.333l3.633-1.65,1.65-3.633,1.65,3.633,3.633,1.65Z",
    transform: "translate(-1 1)",
    fill: "#f28608"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt006ColorDiamond);
export default __webpack_public_path__ + "static/media/PT006_color_diamond.d40480c538ca9a09871073397beaf8ec.svg";
export { ForwardRef as ReactComponent };